export const theme = {
  colors: {
    primary: {
      main: '#2665EB',
      hover: '#1b4bbd',
      light: '#EEF4FF'
    },
    secondary: {
      main: '#475569',
      hover: '#334155',
      light: '#F8FAFC'
    },
    accent: {
      main: '#2665EB',
      hover: '#1b4bbd',
      light: '#EEF4FF'
    },
    success: {
      main: '#059669',
      hover: '#047857',
      light: '#ECFDF5'
    },
    danger: {
      main: '#DC2626',
      hover: '#B91C1C',
      light: '#FEE2E2'
    }
  },
  status: {
    NOUVEAU: 'bg-blue-50 text-blue-700 border-blue-200',
    LEADS: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    MI_CHEMIN: 'bg-amber-50 text-amber-700 border-amber-200',
    PAS_INTERESSE: 'bg-slate-50 text-slate-700 border-slate-200',
    PAS_ELIGIBLE: 'bg-red-50 text-red-700 border-red-200',
    FAUX_NUMERO: 'bg-purple-50 text-purple-700 border-purple-200',
    NRP_1: 'bg-orange-50 text-orange-700 border-orange-200',
    NRP_2: 'bg-orange-100 text-orange-700 border-orange-300',
    NRP_3: 'bg-orange-200 text-orange-800 border-orange-400',
    NRP_4: 'bg-orange-300 text-orange-800 border-orange-500',
    NRP_5: 'bg-orange-400 text-orange-900 border-orange-600'
  }
};